import React from 'react';
import MDElement from '../MDElement';

const Education = () => {
 
    const style = {textAlign: "left"}
    return (
        <>

            <MDElement path="Education/Education.md" />
        </>
    )
};

export default Education;